import React, { useEffect, useState } from 'react'
import Schedule from './Schedule';
import LoginPopUp from '../../Components/LoginPopUp';
import Payment from '../../Components/Payment';
import StepsPopUp from './StepsPopUp';
import { useNavigate } from 'react-router-dom';


function Teacher() {
    const [toggleBtn, settoggleBtn] = useState('formation')
    const [fixContainer, setfixContainer] = useState(false)
    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, []);
    const navigate = useNavigate();

  let handleClick=(event)=>{
    event.stopPropagation()
    navigate("/globalConsultancy/teacher/Payment")
  }
    let skill = ['Microsoft Office', 'Leadership', 'Management', 'Project Management', '  Microsoft Word', 'Research', ' Public Speaking', ' web developer',
        'Java', '  Machine Learning', 'Microsoft Excel', 'Python',
        'Entrepreneurship',
        'Business Development',
        'business Developer']
    let otherConsultancy = [1, 2, 3, 4, 5, 6, 7]
    let review = [1, 2, 3, 4]
    window.addEventListener("scroll", () => {
        let y = window.scrollY
        let div = document.querySelector('.maindiv')
        console.log(y);
        if (y > 300) {
            setfixContainer(true)
        }
        if (y < 200) {
            setfixContainer(false)
        }
        if (y >= (div.offset().top + div.outerHeight() - window.innerHeight)) {
            setfixContainer(false)
        }
    })

    return (
        <div className="white-1 " style={{ marginTop: '13%' }}>
        
            <div className="row justify-content-center w-100  flex-row-reverse maindiv" >

                <div className="mx-1 col-md-5    " >
                    <div className={`position-${fixContainer && "fixed py-5 pr-4 h-75"}  `} style={{ bottom: '15%', transition: ".5s" }}>
                        <div className="d-flex flex-column p-3" style={{ backgroundColor: '#1A1A40', height: 'auto' }}>
                            <div className="my-2 d-flex justify-content-between">
                                <h4 className="white-2">Trail Lessons</h4>
                                <h3>INR 100</h3>
                            </div>
                            <div className="my-2 d-flex justify-content-between">
                                <h4 className="white-2"> Lessons</h4>
                                <h3>INR 500</h3>
                            </div>
                            <a className="btn w-100  letter-dis-2  align-self-center" style={{ background: "#E65100" }} onClick={handleClick} >Book lessons</a>
                            <a className="btn w-100 teal darken-2  letter-dis-2  align-self-center" style={{ background: "#E65100" }}>Contact Teacher</a>
                        </div>

                        <div className="my-3 " style={{ backgroundColor: '#1A1A40' }}>
                            <Schedule />
                        </div>

                    </div>
                </div>
                <div className=" col-md-6 rounded d-flex flex-column  p-4" style={{ backgroundColor: '#1A1A40' }}>
                    <div className="d-flex justify-content-between">


                        <div class={`embed-responsive embed-responsive-16by9 align-self-center  rounded hoverable  animated fadeIn d-flex `} style={{ width: "80%", height: "100%" }} >
                            <iframe class="embed-responsive-item" width="560" height="315" style={{ height: "101%" }} src="https://www.youtube.com/embed/chRx0xsLGAk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                        <div className="col-md-3 text-right align-self-end ">
                            <div className="d-flex justify-content-end py-1 m-1">
                                <ion-icon name="share-outline"  style={{ fontSize: "26px", cursor: "pointer" }}></ion-icon>
                                <ion-icon name="heart-outline"  style={{ fontSize: "26px", cursor: "pointer" }}></ion-icon>
                                <ion-icon name="caret-down-outline"  style={{ fontSize: "26px", cursor: "pointer" }}></ion-icon>
                            </div>
                            <p className="white-2">17 Lessons</p>
                            <p className="white-2">35 students</p>
                            <div className="review mt-3 white-3 " style={{ whiteSpace: "nowrap" }}>
                                <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                                <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                                <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                                <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                                <ion-icon name="star-half-outline" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                                &#160;4.5
                            </div>
                        </div>
                    </div>
                    <div className='p-3 align-self-center text-center'>

                    </div>
                    <div className="row justify-content-around">
                        <div className="col-md-4 d-flex flex-column align-items-start " style={{ borderRight: "1px solid #424242" }} >
                            <img src={require(`../../resource/testimonial-1.jpg`)} style={{ width: '100px', height: '100px', boxShadow: '0 0 0  5px purple' }} className="rounded-circle " alt="" />
                            <h4 className="my-2">Pratik Gandhi</h4>
                            <span clacssName="white-3 h6" style={{ borderBottom: "3px dashed #800080" }}>Community Tutor</span>
                            <p>From Canada</p>
                            <p>Living in Hamilton, Canada (06:13 UTC-05:00)</p>
                        </div>

                        <div className="col-md-6 d-flex flex-column  align-items-start p-0">
                            <p className="white-2" >
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla molestias nam explicabo aspernatur, possimus expedita, necessitatibus sed adipisci fugit repellendus enim magnam laboriosam obcaecati maxime ab culpa! Tempora quidem omnis molestias itaque ex ratione minus debitis atque nulla consectetur aliquam nam repellat, accusamus deleniti, quibusdam facere, laudantium esse sapiente suscipit?
                            </p>
                            <div className="d-flex ">
                                <p className="white-3 mr-3">Speaks ---</p>
                                <h6 className="white-2">English</h6>
                            </div>
                            <div className="d-flex">
                                <p className="white-3 mr-3">Also Speaks</p>
                                <div className="d-flex">
                                    <h6 className="mr-5 white-2">French</h6>
                                    <h6 className="white-2">Portuguese</h6>
                                </div>
                            </div>
                        </div>




                        <h4 className="white-1 text-center mt-3">Speaking Tutor for Canadian Immigrants</h4>
                        <div className="mt-3"  >
                            <span className="white-2" style={{ borderBottom: "3px dashed grey" }}>Consultancy details</span>
                            <p className="white-3 my-3">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facere aut quaerat architecto vitae illo necessitatibus vel tenetur possimus, doloremque quasi, delectus minus adipisci blanditiis eius nam rerum soluta dolorem eaque cum, magnam similique libero deleniti. Ullam ea hic odit reprehenderit unde iusto rerum, quibusdam dolor. Officiis quo ex libero totam harum error optio sed. Placeat aliquid ratione non quas recusandae minima culpa iusto, commodi sint quia libero numquam illo cupiditate deleniti quisquam labore ex repellendus natus a dicta quibusdam, asperiores tempore? Blanditiis, ipsam? Neque aliquam rem quia fugiat, est doloribus iusto non atque sed dolorem, voluptatum assumenda, nam quibusdam ut!</p>
                        </div>
                    </div>


                    <div className="d-flex justify-content-center m-3" onClick={(event) => event.stopPropagation()}>
                        <div className="btn-group w-100 " >
                            <a onClick={() => settoggleBtn('formation')} className={`btn-lg   ${toggleBtn === 'formation' ? "purple darken-2 " : "purple darken-4 "} rounded text-white text-center mr-2`} style={{ width: "33%" }}>Formation</a>
                            <a onClick={() => settoggleBtn('experience')} className={`btn-lg ${toggleBtn === 'experience' ? "purple darken-2" : "purple darken-4 "} rounded text-white text-center mr-2`} style={{ width: "33%" }}>Experience</a>
                            <a onClick={() => settoggleBtn('skills')} className={`btn-lg ${toggleBtn === 'skills' ? "purple darken-2" : "purple darken-4 "} rounded text-white text-center`} style={{ width: "33%" }}>Skills</a>
                        </div>
                    </div>

                    {/*--- formation part ---*/}
                    <div className={`${toggleBtn !== 'formation' && "d-none"} flex-wrap justify-content-between animated fadeIn`}>
                        <div className="d-flex shadow-lg rounded pt-2 mb-2" style={{ borderBottom: "1px solid #525252" }} >
                            <div className="mx-1">
                                <ion-icon name="school-outline" style={{ fontSize: "50px" }}></ion-icon>
                            </div>
                            <div>
                                <h5>University of Nevada, Reno</h5>
                                <h6 className="white-2">Master of Science - MS</h6>
                                <p className="white-3">2017 - 2019</p>
                            </div>
                        </div>
                        <div className="d-flex shadow-lg rounded pt-2 mb-2" style={{ borderBottom: "1px solid #525252" }} >
                            <div className="mx-1">
                                <ion-icon name="school-outline" style={{ fontSize: "50px" }}></ion-icon>
                            </div>
                            <div>
                                <h5>West Bengal University of Technology, Kolkata</h5>
                                <h6 className="white-2">Bachelor of Technology (B.Tech.), Electrical, Electronics and Communications Engineering</h6>
                                <p className="white-3">2008 - 2012</p>
                            </div>
                        </div>
                        <div className="d-flex  shadow-lg rounded pt-2 mb-2" style={{ borderBottom: "1px solid #525252", }} >
                            <div className="mx-1">
                                <ion-icon name="school-outline" style={{ fontSize: "50px" }}></ion-icon>
                            </div>
                            <div className="align-self-center">
                                <h5>St Lawrence High School</h5>
                                <h6 className="white-2">High School, Science</h6>
                                <p className="white-3">1995 - 2008</p>
                            </div>
                        </div>
                    </div>

                    {/*--- experience part ---*/}
                    <div className={`${toggleBtn !== 'experience' && "d-none"}  animated fadeIn`}>
                        <div className="d-flex  shadow-lg rounded pt-2 mb-2" style={{ borderBottom: "1px solid #525252" }} >
                            <div className="mx-1 align-self-center">
                                <ion-icon name="business-outline" style={{ fontSize: "50px", color: "#bdbcb9" }}></ion-icon>
                            </div>
                            <div>
                                <h5>National Student Entrepreneur Status</h5>
                                <h6 className="white-2">Pépite PON · Contract Part-time</h6>
                                <h6 className="white-2">Sep 2021 - Present · 7 mos</h6>
                                <p className="white-3">Paris, Île-de-France, France</p>
                            </div>
                        </div>
                        <div className="d-flex  shadow-lg rounded pt-2 mb-2" style={{ borderBottom: "1px solid #525252" }} >
                            <div className="mx-1 align-self-center">
                                <ion-icon name="business-outline" style={{ fontSize: "50px", color: "#bdbcb9" }}></ion-icon>
                            </div>
                            <div>

                                <h5>Doctorate Student</h5>
                                <h6 className="white-2">Université de Tours · Contract</h6>
                                <h6 className="white-2">Oct 2021 - Present · 6 mos</h6>
                                <p className="white-3">Tours, Centre-Val de Loire, France</p>
                            </div>
                        </div>
                        <div className="d-flex  shadow-lg rounded pt-2 mb-2" style={{ borderBottom: "1px solid #525252" }} >
                            <div className="mx-1 align-self-center">
                                <ion-icon name="business-outline" style={{ fontSize: "50px", color: "#bdbcb9" }}></ion-icon>
                            </div>
                            <div>
                                <h5>Founder and Director</h5>
                                <h6 className="white-2">DOTS (Digital Optimized and Tenacious Solutions) · Self-employed</h6>
                                <h6 className="white-2">Jul 2019 - Present · 2 yrs 9 mos</h6>
                                <p className="white-3">Paris, Île-de-France, France</p>
                                <p className="white-3">DOTS is an IT consultant firm which provide different services web, mobile, game, AR/VR, software applications design and development services.
                                </p>
                            </div>
                        </div>
                        <div className="d-flex  shadow-lg rounded pt-2 mb-2" style={{ borderBottom: "1px solid #525252" }} >
                            <div className="mx-1 align-self-center">
                                <ion-icon name="business-outline" style={{ fontSize: "50px", color: "#bdbcb9" }}></ion-icon>
                            </div>
                            <div>
                                <h5>Founder</h5>
                                <h6 className="white-2">Pramit Foudation Educational Society</h6>
                                <h6 className="white-2">Jun 2019 - Present · 2 yrs 10 mos</h6>
                                <p className="white-3">Datia, Madhya Pradesh, India</p>
                            </div>
                        </div>

                    </div>
                    <div className={`${toggleBtn === 'skills' ? "d-flex" : "d-none"} flex-wrap justify-content-center animated fadeIn`}>
                        {skill.map((skill) => {
                            return <div className=" shadow-lg p-3 m-1" style={{ borderRadius: "30px", border: "1px solid #525252" }}>{skill}</div>
                        })}
                    </div>


                    <div className="mt-3">
                        <h4 className="white-2">Other consultancy</h4>
                        {otherConsultancy.map((item) => {
                            return <div className="d-flex justify-content-between rounded align-items-center my-2 p-2" style={{ border: "1px solid #525252" }}>
                                <div>
                                    <h5 className="white-1">Universal English Courses</h5>
                                    <p className="white-2">3 Lessons</p>
                                </div>
                                <div className="rounded teal p-2">INR 480+</div>
                            </div>
                        })}
                    </div>

                    <div className="my-3">
                        <h3 className="text-center">4 Reviews</h3>
                        <div className="row flex-wrap justify-content-center p-3">
                            {review.map((rev) => {
                                return <div className="col-md-5 p-3 rounded m-3 deep-purple darken-4 shadow">
                                    <div className="d-flex justify-content-between  align-items-end">
                                        <div>
                                            <img src={require(`../../resource/avater.png`)} width="60" height="60" className="p-1 mb-1 rounded-circle" style={{ background: "grey" }} alt="" />
                                            <h5>Anita kumari</h5>
                                        </div>
                                        <div className="review white-3 " style={{ whiteSpace: "nowrap" }}>
                                            <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                                            <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                                            <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                                            <ion-icon name="star-half-outline" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                                            <ion-icon name="star-outline" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                                            &#160;
                                        </div>

                                    </div>
                                    <i className="white-3" >
                                        " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Vero animi saepe pariatur beatae assumenda dolore reiciendis, eos omnis modi sunt tempore non. Rem, provident praesentium id, possimus, quisquam beatae cumque quis vero est saepe repudiandae? "
                                    </i>
                                </div>

                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Teacher